export const COMPANY_NAME = "Booking.com";

export const IMAGE_STATIC_ASSETS_URL = "https://q-xx.bstatic.com";

export const PRIVACY_AND_COOKIE_STATEMENT_URL = "https://admin.booking.com/hotel/hoteladmin/privacy.html";

export const TERMS_AND_CONDITONS_URL = "/terms.html";

export const HOW_TO_GUIDE_URL = "/how-to-guide";
